<template>
  <div
    ref="trigger"
    v-click-outside="closeDropdown"
    class="relative !h-full"
  >
    <button
      class="!text-sm font-medium block no-underline py-1.5 px-2.5 border-b last:border-b-0 lg:border-0 group
      hover:bg-secondary-light/15 h-fit"
      :class="{ '!bg-[#FFFFFF29] !border-[#FFFFFF29]': btnActive || itemActive || open }"
      @click.stop="toggleDropdown"
    >
      Catalytic Projects

      <FontAwesomeIcon
        :icon="faCaretDown"
        class="pl-1"
      />
    </button>

    <!-- Dropdown menu -->
    <div
      v-show="open"
      ref="floating"
      :style="floatingStyles"
      class="z-[70] min-w-max bg-secondary !duration-0 w-full !rounded-[1px] overflow-hidden"
    >
      <ButtonBannerPlan
        text="Manage Catalytic Projects"
        :to="{ name: 'app_plan_table' }"
        class="block !rounded-b-none !border-0 !border-b border-secondary-light/40 !rounded-t-md"
        @click="closeDropdown"
      />

      <ButtonBannerPlan
        text="GeoMap View"
        :to="{ name: 'app_plan_geo_map' }"
        class="block !rounded-t-none !border-0 !rounded-b-md"
        @click="closeDropdown"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useFloating, offset, flip } from '@floating-ui/vue';
import { useRoute } from 'vue-router';
import { ButtonBannerPlan } from '@/components/buttons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

const route = useRoute();

const btnActive = computed(() => route.name === 'app_plan_table');
const itemActive = computed(
  () => route.name === 'app_plan_table' || route.name === 'app_plan_geo_map',
);

const open = ref(false);
const trigger = ref();
const floating = ref();
let floatingStyles;

const toggleDropdown = () => open.value = !open.value;
const closeDropdown = () => open.value = false;

onMounted(() => {
  const { floatingStyles: styles } = useFloating(trigger, floating, {
    middleware: [offset(5), flip()],
    placement: 'bottom-start',
    open,
  });
  floatingStyles = styles;
});
</script>
